'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Plugin = undefined;

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Plugin = exports.Plugin = undefined;

exports.Plugin = Plugin = function Plugin(_ref) {
    var refs = _ref.refs,
        _ref$inits = _ref.inits,
        inits = _ref$inits === undefined ? [] : _ref$inits,
        renderFn = _ref.renderFn,
        initializeFn = _ref.initializeFn,
        type = _ref.type;

    var t = this;

    // public properties
    t.url = null;
    t.username = null;
    t.password = null;
    t.auth = null;
    t.loadingIndicator = false;

    // private properties
    var _layouts = [];
    var _isPending = false;
    var _isReady = false;

    // public functions
    t.add = function () {
        for (var _len = arguments.length, layouts = Array(_len), _key = 0; _key < _len; _key++) {
            layouts[_key] = arguments[_key];
        }

        layouts = (0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts;

        if (layouts.length) {
            _layouts = [].concat(_toConsumableArray(_layouts), _toConsumableArray(layouts));
        }
    };

    t.load = function () {
        for (var _len2 = arguments.length, layouts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            layouts[_key2] = arguments[_key2];
        }

        t.add((0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts);

        _runFn();
    };

    t.getType = function () {
        return type;
    };

    // private functions
    var _readyFn = function _readyFn() {
        _isReady = true;
        _isPending = false;
    };

    var _pendingFn = function _pendingFn() {
        _isPending = true;
    };

    var _runFn = function _runFn() {
        var initializeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeFn || _initializeFn;

        if (_isReady) {
            while (_layouts.length) {
                renderFn(t, _layouts.shift());
            }
        } else if (!_isPending) {
            _pendingFn();

            initializeFn();
        }
    };

    var _initializeFn = function _initializeFn() {
        var readyFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _readyFn;
        var runFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _runFn;
        var appManager = refs.appManager,
            requestManager = refs.requestManager,
            init = refs.init;
        var Request = refs.api.Request;


        var credentials = t.username && t.password ? t.username + ':' + t.password : null;
        var auth = t.auth;

        appManager.setAuth(credentials, auth);
        appManager.path = t.url;

        // user account
        new Request(refs, {
            baseUrl: appManager.getApiPath() + '/me.json',
            type: 'json',
            param: ['fields=id,firstName,surname,userCredentials[username],settings'],
            success: function success(response) {
                appManager.userAccount = response;

                // inits
                inits.forEach(function (initFn) {
                    return requestManager.add(new Request(refs, initFn(refs)));
                });

                readyFn();

                requestManager.set(runFn);
                requestManager.run();
            }
        }).run();
    };
};
//# sourceMappingURL=Plugin.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/util/Plugin.js
 ** module id = 160
 ** module chunks = 0 1
 **/